import { Box, Chip, Skeleton, Typography } from "@mui/material";
import theme from "theme";

import { memo } from "react";
import styled from "styled-components";

import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export type Category = {
  id: number;
  name: string;
};

type Props = {
  categories: Category[];
  selectedCategories: string[];
  toggleCategory: (name: string) => void;
  isLoading: boolean;
  isError: boolean;
};

const GamesFilterButton = ({
  categories,
  selectedCategories,
  toggleCategory,
  isLoading,
  isError,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        justifyContent: "center",
      }}
    >
      <FilterItems>
        <FilterTitle>
          <FilterAltOutlinedIcon sx={{ color: "#fff" }} />
          <Typography
            color="textPrimary"
            sx={{ fontWeight: "700", fontSize: 14 }}
          >
            絞り込む
          </Typography>
        </FilterTitle>

        {isLoading || isError ? (
          <>
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={100}
                height={32}
                sx={{ borderRadius: "100px" }}
              />
            ))}
          </>
        ) : (
          <>
            {categories.map((item) => {
              const isSelected = selectedCategories.includes(item.name);
              return (
                <Chip
                  key={item.id}
                  variant={isSelected ? "filled" : "outlined"}
                  color={isSelected ? "secondary" : "default"}
                  label={item.name}
                  onClick={() => toggleCategory(item.name)}
                  onDelete={
                    isSelected
                      ? () => {
                          toggleCategory(item.name);
                        }
                      : undefined
                  }
                />
              );
            })}
          </>
        )}
      </FilterItems>
    </Box>
  );
};

const FilterTitle = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;

  ${theme.breakpoints.down("sm")} {
    width: 100%;
    justify-content: center;
  }
`;
const FilterItems = styled.div`
  display: inline flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  ${theme.breakpoints.down("md")} {
    gap: 12px;
  }
  ${theme.breakpoints.down("sm")} {
    gap: 8px;
  }
`;

export default memo(GamesFilterButton);
